import {http} from "http/index";

const prefix = "/agent-notifications/preferences/company";

export const getUserNotificationSettings = async companyId => http.get(`${prefix}/${companyId}`);

export const updateUserNotificationSettings = async ({data, companyId}) =>
  http.put(`${prefix}/${companyId}`, data);
